export default "CEE Collectivités 2026 — Primes pour Travaux dans le Patrimoine Public | Solution Éco France";
